import { createTheme } from "@mui/material";
import json2mq from 'json2mq';

const mq = `@media ${json2mq({ minWidth: 600 })}`;

export const theme = createTheme({
  typography: {
    fontFamily: "Prompt, sans-serif",
    body: {
      fontSize: 15,
    },
    bold: {
      fontWeight: 500,
    },
    "heavy-bold": {
      fontWeight: 700,
    },
    caption: {
      fontFamily: "Inter, sans-serif",
      fontSize: 15,
      [mq]: {
        fontSize: 20,
      },
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#000",
      contrastText: "#fff",
    },
    link: {
      main: "#fff",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 10,
          fontSize: 16,
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          [mq]: {
            fontSize: 20,
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#000",
          color: "#fff",
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: ({ theme }) => ({
          width: 42,
          height: 26,
          padding: 0,
          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
              transform: "translateX(16px)",
              color: "#fff",
              "& + .MuiSwitch-track": {
                backgroundColor: "#FFF",
                opacity: 1,
                border: 0,
                ...theme.applyStyles("dark", {
                  backgroundColor: "#FFF",
                }),
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.5,
              },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
              color: "#FFF",
              border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: theme.palette.grey[100],
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.7,
            },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 22,
            height: 22,
            color: "#000",
          },
          "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: "#FFF",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
              duration: 500,
            }),
          },
        }),
      },
    },
  },
});
